interface TypographyProps {
    children: React.ReactNode;
    className?: string;
}

export const TitleMedium = ({ children, className = '' }: TypographyProps) => {
    return (
        <h2 className={`font-outfit font-bold text-2xl leading-7 lg:text-[40px] lg:leading-[48px] ${className}`}>
            {children}
        </h2>
    );
};